import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=05dee34f&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=05dee34f&prod&lang=less&scoped=true"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=05dee34f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dee34f",
  null
  
)

export default component.exports